document.addEventListener('DOMContentLoaded' , function(){
    document.addEventListener('click' , function(e){
        const openButton = e.target.closest("[data-open-size-guide]");
        const closeBtn = e.target.closest(".size-guide-close");
        const overlay = e.target.classList.contains("size-guide-overlay");
        const tab = e.target.closest('[data-tab]');

        const modal =document.getElementById("SizeGuideModal");

        if (openButton){
            modal.classList.add('is-open');
            document.body.style.overflow ="hidden";
        }

        if (closeBtn || overlay){
            modal.classList.remove('is-open');
            document.body.style.overflow ="";
        }

        if(!tab) return;

        const container = tab.closest('[data-size-tabs]');
        const value = tab.dataset.tab;

        container.querySelectorAll('.size-tab').forEach( t => {
            t.classList.toggle('is-active', t === tab);
        })

        container.querySelectorAll('.size-tab-panel').forEach(panel =>
        panel.classList.toggle('is-active', panel.dataset.panel === value)
        );
    })
    


})